import React from "react";
import { VideoPlayer } from "../players/VideoPlayer";

/**
 * InstructionsPage component that displays an instructional video.
 * 
 * @returns {JSX.Element} The rendered instructions page with a video player.
 */
export function InstructionsPage() {
  const url = "https://sadima.lnu.se/Media/Filmer/Instruktioner.mp4";

  return (
    <div className="full-width-container">
      <h2 className="content-header">Instruktioner</h2>
      <div className="content-frame">
        <VideoPlayer url={url}/>
      </div>
    </div>
  );
}
